<template lang="pug">
	section#formulario
		.wrapper
			div.img
				img(:src="require('@images/others/sir.png')")
			div.form
				p É a sua hora de viver essa experiência na FAEL.
				h2 Faça parte do nosso compromisso
				form(@submit.prevent="sendInscreva")
					div(:class="{ error: errors.nome }").input.margin
						label(for="nome") Nome
						input(type="text", v-model="inscreva.nome", id="nome" name="nome")
						span(v-if="errors.nome") {{ errors.nome[0] }}
					div(:class="{ error: errors.email }").input.margin
						label(for="email") Email
						input(type="email", v-model="inscreva.email", id="email" name="email")
						span(v-if="errors.email") {{ errors.email[0] }}
					div(:class="{ error: errors.celular }").input
						label(for="celular") Telefone
						input(type="tel", v-model="inscreva.celular", id="celular" name="celular", v-mask="['(##) #####-####', '(##) ####-####']")
						span(v-if="errors.celular") {{ errors.celular[0] }}
					div.check.margin
						span Podemos usar o WhatsApp e/ou SMS para falar sobre sua inscrição, matrícula e prestação de serviços?
						label(for="checkContatoWhatsapp")
							input(type="checkbox", id="checkContatoWhatsapp", name="checkContatoWhatsapp", v-model="inscreva.contato_whatsapp")
							| Autorizo o uso do WhatsApp e/ou SMS no telefone informado.
					// div(:class="{ error: errors.curso_interesse }").input
					//     label(for="curso_interesse") Curso de Interesse
					//     input(type="text", v-model="inscreva.curso_interesse", id="curso_interesse" name="curso_interesse")
					//     span(v-if="errors.curso_interesse") {{ errors.curso_interesse[0] }}
					button(:disabled="sending").enviar {{ button }}
</template>

<script>
import { mask } from 'vue-the-mask'

export default {
	name: "formulario",
	directives: {
		mask
	},
	data() {
		return {
			sending: false,
			button: 'Enviar',
			errors: {},
			inscreva: {
				nome: '',
				email: '',
				celular: '',
				contato_whatsapp: false,
				// curso_interesse: '',
				origem: 'CompromissoFAEL',
				form_origem: 'form_compromisso',
				has_celular: true
			},

		}
	},
	methods: {
		sendInscreva() {
			this.sending = true
			this.button = "Enviando"
			this.$axios
				.post(`${process.env.VUE_APP_API_ROUTE}/save-lead`, this.inscreva)
				// eslint-disable-next-line
				.then(response => {
					this.button = "Enviado!"

					this.sendServlet();
				})
				.catch(error => {
					this.sending = false
					if (error.response && error.response.status == 422)
						this.errors = error.response.data.error_validate
				})
				.finally(() => {
					setTimeout(() => {
						this.sending = false
						this.button = "Enviar"
					}, 2500)
				})
		},
		sendServlet() {
			let name = this.inscreva.nome.split(' ');
			let last_name = ''
			for (let i = 1; i < name.length; i++) {
				last_name = last_name + ' ' + name[i];
			}
			try {
				this.$axios
					.post(`https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8`, {
						oid: '00D1a000000HHaH',
						retURL: 'https://subs.fael.edu.br/',
						first_name: name[0],
						last_name,
						lead_source: window.location.referrer,
						mobile: this.inscreva.celular,
						email: this.inscreva.email,
						'00N1a000009fxkB': window.location.referrer,
						'00N1a000009fxZr': 'CompromissoFAEL',
						'00N1a000009fxa8': '000',
						'00N1a000009fxa0': '000',
						'00N1a000009fxaO': '-- Nenhum –-',
						'00N1P00000AWwUw': this.inscreva.contato_whatsapp
					}, {
						crossDomain: true,
					})
					.then(() => {
						setTimeout(() => {
							window.location.href = `https://subs.fael.edu.br/?v1=${this.inscreva.nome}&v2=${this.inscreva.email}&v3=${this.inscreva.celular}&v4=&v5=&v6=&v7=&v8=${this.inscreva.origem}&v12=${this.inscreva.contato_whatsapp}`
						}, 500)
					})
					.fail(() => {
						setTimeout(() => {
							window.location.href = `https://subs.fael.edu.br/?v1=${this.inscreva.nome}&v2=${this.inscreva.email}&v3=${this.inscreva.celular}&v4=&v5=&v6=&v7=&v8=${this.inscreva.origem}&v12=${this.inscreva.contato_whatsapp}`
						}, 500)
					})
			} catch (error) {
				console.log(error)
				setTimeout(() => {
					window.location.href = `https://subs.fael.edu.br/?v1=${this.inscreva.nome}&v2=${this.inscreva.email}&v3=${this.inscreva.celular}&v4=&v5=&v6=&v7=&v8=${this.inscreva.origem}&v12=${this.inscreva.contato_whatsapp}`
				}, 500)
			}
		}
	},
}
</script>

<style lang="stylus" scoped src="./Formulario.styl"></style>